import React from 'react'

import PropTypes from 'prop-types'

import './component3images.css'

const Component3images = (props) => {
  return (
    <div className={`component3images-container ${props.rootClassName} `}>
      <img
        alt={props.image1Alt}
        src={props.image1Src}
        loading="lazy"
        className="component3images-thq-image1-elm"
      />
      <img
        alt={props.image2Alt}
        src={props.image2Src}
        loading="lazy"
        className="component3images-thq-image2-elm"
      />
      <img
        alt={props.image3Alt}
        src={props.image3Src}
        loading="lazy"
        className="component3images-thq-image3-elm"
      />
    </div>
  )
}

Component3images.defaultProps = {
  rootClassName: '',
  image1Src: '',
  image3Src: '',
  image2Src: '',
  image1Alt: '',
  image3Alt: '',
  image2Alt: '',
}

Component3images.propTypes = {
  rootClassName: PropTypes.string,
  image1Src: PropTypes.string,
  image3Src: PropTypes.string,
  image2Src: PropTypes.string,
  image1Alt: PropTypes.string,
  image3Alt: PropTypes.string,
  image2Alt: PropTypes.string,
}

export default Component3images
